import { IonCol, IonItemDivider, IonLabel, IonList, IonRow } from '@ionic/react'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import SingleSelect from '../../../components/singleSelect/SingleSelect.component'
import SInput from '../../../components/stringInput/StringInput.component'
import {
  setAmbulanceTransportCode,
  setBaseOption,
  setDispatchedAs,
  setDispatchLocation,
  setDispatchPriority,
  setDisposition,
  setMassCasualty,
  setPatientCategory,
  setDispatchID,
  setRegTailNumberOption,
  setScheduled,
  setShift,
  setStaffingLevel,
  setTypeofService,
  setVehicleGPSE,
  setVehicleGPSN,
  setVehicleGrid,
  setVehicleUSNG,
  calculateVehicleUsng,
  setVehicleMileageStart,
  setVehicleMileageRef,
  setVehicleMileageEnd,
  setVehicleMileageRec,
  CalculateVehicleMileageLoaded,
  CalculateVehicleMileageTotal,
  setVehicleMileageLoaded,
  setVehicleMileageTotal,
  setUnitDisposition,
  setPatientEvaluation,
  setCrewDisposition,
  setRefusalReleaseReason,
  setTransportDisposition,
  setUnitEquipment,
  setEmdPerformed,
  setEmd,
  setUnitOption,
  setEmdPerformedPNNV,
  setMassCasualtyPNNV,
  setCrewDispositionPNNV,
  setTransportDispositionPNNV,
  setPatientEvaluationPNNV,
  setLocalId,
  setCallType,
  setStandbyPurpose,
  setTeam,
  setTeamCareOnly,
  setEquipment,
  setProviderRoles,
  setMaxAlt,
  setFlightPlan,
} from '../store/tripInformation.actions'
import { getTripInformationSelector } from '../selectors'
import { getTripInformationOptionsSelector } from '../../options/selectors/tripInformationOptions.selector'
import { IOption, IOptionWithKey, IPNNVOption } from '../../../common/common.types'
import { IPHIComponent } from '../../../components/phi/phi.component'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'
import NumberPad from '../../../components/numberPad/NumberPad.component'
import { geoLocationKeys, numberPadKeysWithDecimal } from '../../../components/numberPad/NumberPad.types'
import './TripInformation.component.css'
import Validation from '../../../components/validation/Validation.component'
import { TripInformationConstants } from '../store/tripInformation.constants'
import { getConfigurationsSelector } from '../../../features/configurations/selectors/configurations.selector'
import { IConfigurationsState, IDataPointsConfig } from '../../../features/configurations/store/configurations.types'
import { removeExtraDecimalPoints } from '../../../utilities/string.util'
import * as actions from '../../crew/store/crew.actions'
import { getCadImportSelector } from '../../cadImport/selectors'
import { AccordianComponent } from '../../../components/accordian/Accordian.components'
import MultiSelect from '../../../components/multiSelect/MultiSelect.component'
import { ITripInformationState } from '../store/tripInformation.types'
import { getCrewSelector } from '../../crew/selectors'
import { IDispatchPriorityOption, IDispositionOption, IUnitOption } from '../../options/store/options.types'
import { getDatapointsConfigSelector } from '../../configurations/selectors'
import { getResponseMode, hideDisableDateTimesBasedOnDisposition } from '../utils/tripInformation.util'
import { getPickupAddressOptionsSelector } from '../../options/selectors/pickupAddressOptions.selector'
import * as pickupAddressActions from '../../../features/pickupAddress/store/pickupAddress.actions'
import { IRootState } from '../../../store'
import { setTimes } from '../../times/store/times.actions'
import { showAlert } from '../../../components/alert/store/alert.actions'
import { supportsMaxAlt } from '../utils/tripInformation.util'

const TripInformationContent: React.FC<IPHIComponent> = (props: IPHIComponent) => {
  const { t } = useTranslation()
  const { isPHI } = props
  const dispatch = useDispatch()
  const inputRef = useRef<HTMLIonInputElement | null>(null)

  const configurationsState: IConfigurationsState = useSelector(getConfigurationsSelector)
  const { serviceConfig } = configurationsState
  const {
    PR_USNG,
    FORCE_MILEAGE_TENTHS,
    PR_DISPATCH_ID,
    PR_DISP_FIELDS,
    PR_DISPATCHED_AS,
    PR_NEMSIS35_DISPOSITION,
    PR_LOCAL_ID,
    PR_LOCAL_ID_LABEL,
    PR_DISPATCHED_LOS,
    PR_TAIL_NUMBER,
    PR_PTCAT_DISP_MAP,
    TEAM_CAPABLE,
  } = serviceConfig

  const crew = useSelector(getCrewSelector)
  const { unitEquipmentOptions } = crew
  const tripInformationState: ITripInformationState = useSelector(getTripInformationSelector)
  const {
    base,
    unit,
    staffingLevel,
    unitEquipment,
    shift,
    dispatchID,
    localId,
    registrationTailNumber,
    dispatchPriority,
    emdPerformed,
    emdPerformedPNNV,
    emd,
    typeofService,
    scheduled,
    standByPurpose,
    callType,
    patientCategory,
    dispatchedAs,
    disposition,
    unitDisposition,
    crewDisposition,
    crewDispositionPNNV,
    patientEvaluation,
    patientEvaluationPNNV,
    transportDisposition,
    transportDispositionPNNV,
    refusalReleaseReason,
    ambulanceTransportCode,
    massCasualty,
    massCasualtyPNNV,
    dispatchLocation,
    vehicleGPSN,
    vehicleGPSE,
    vehicleUSNG,
    vehicleGrid,
    vehicleMileageStart,
    vehicleMileageRef,
    vehicleMileageEnd,
    vehicleMileageRec,
    vehicleMileageLoaded,
    vehicleMileageTotal,
    lpm_lpm,
    lpm_odom,
    team,
    teamCareOnly,
    equipment,
    providerRoles,
    maxAlt,
    flightPlan,
  } = tripInformationState

  const tripInfoOptions = useSelector(getTripInformationOptionsSelector)
  const {
    massCasualtyOptions,
    vehicleGridOptions,
    ambulanceTransportCodeOptions,
    dispositionOptions,
    unitDispositionOptions,
    patientEvaluationOptions,
    crewDispositionOptions,
    transportDispositionOptions,
    refusalReleaseReasonOptions,
    dispatchedAsOptions,
    patientCategoryOptions,
    baseOptions,
    unitOptions,
    staffingLevelOptions,
    shiftOptions,
    registrationTailOptions,
    dispatchPriorityOptions,
    emdPerformedOptions,
    typeofServiceOptions,
    standByPurposeOptions,
    scheduledOptions,
    callTypeOptions,
    teamOptions,
    teamCareOnlyOptions,
    equipmentOptions,
    providerRolesOptions,
    flightPlanOptions,
  } = tripInfoOptions

  const pickupAddressOptionsState = useSelector(getPickupAddressOptionsSelector)
  const { responseModeOptions, responseModeCustomOptions } = pickupAddressOptionsState
  const cadImportState = useSelector(getCadImportSelector)
  const { importedCadData, hasImportedCadData } = cadImportState

  const [isFocused, setIsFocused] = useState(false)
  const isImportedCAD = importedCadData?.length || hasImportedCadData
  const { isTablet: isTabletDevice } = useDeviceMetrics()

  const dataPointsConfig: IDataPointsConfig = useSelector(getDatapointsConfigSelector)
  const times = useSelector((state: IRootState) => state.times)

  const { DP_MASSCAS, DP_MAXALT, DP_IFR } = dataPointsConfig

  const showFlightInfoSection = (DP_MAXALT === 1 || DP_IFR === 1) && supportsMaxAlt(unit)
  const showMaxAltRow = DP_MAXALT === 1 && unit?.showMaxAlt === 1

  const typeOfServiceStandByOption = {
    id: 4,
    name: 'Standby',
  }

  const isStandbyPurposePicklistVisible = typeofService?.id === typeOfServiceStandByOption?.id

  const handleRef = (focus: boolean) => {
    if (!focus) inputRef.current = null
  }

  const setBaseOnChange = (option: IOption) => {
    dispatch(setBaseOption(option))
  }

  const setUnitOnChange = (option: IUnitOption) => {
    dispatch(setUnitOption(option))
    if (option && option.equipmentLevel !== null) {
      dispatch(setUnitEquipment(unitEquipmentOptions.find((uEquipment) => uEquipment.id === option.equipmentLevel)))
    }
    if (option === null && unitEquipment !== null) {
      dispatch(setUnitEquipment(null))
    }
    if (option && supportsMaxAlt(option) && option.defaultAltitude !== null) {
      dispatch(setMaxAlt(option.defaultAltitude))
    } else {
      dispatch(setMaxAlt(''))
      dispatch(setFlightPlan(null))
    }
  }

  const setStaffingLevelOnChange = (option: IOption) => {
    dispatch(setStaffingLevel(option))
    dispatch(actions.setStaffingLevel(option))
    dispatch(actions.setPersistShiftStartup())
  }

  const unitEquipmentOnChange = (option: IOptionWithKey) => {
    dispatch(setUnitEquipment(option))
  }

  const setShiftOnChange = (option: IOption) => {
    dispatch(setShift(option))
  }

  const setDispatchIDOnChange = (e: CustomEvent) => {
    dispatch(setDispatchID(e.detail.value))
  }

  const setLocalIDOnChange = (e: CustomEvent) => {
    dispatch(setLocalId(e.detail.value))
  }

  const setRegistrationTailNumberOnChange = (option: IOption) => {
    dispatch(setRegTailNumberOption(option))
  }

  const getResponseModeOptions = () => {
    if (serviceConfig.PR_REFREC_MODE === 2 && responseModeCustomOptions?.length > 0) {
      return responseModeCustomOptions
    }
    return responseModeOptions
  }

  const setDispatchPriorityOnChange = (option: IDispatchPriorityOption) => {
    const responseModeOption = getResponseMode(option?.emergency || 0, getResponseModeOptions(), unit?.lights || null)
    dispatch(pickupAddressActions.setPickupAddressDefaultsWithResponseMode(responseModeOption))
    dispatch(setDispatchPriority(option))
  }

  const setEmdPerformedOnChange = (option: IOption) => {
    dispatch(setEmdPerformed(option))
  }

  const setEmdPerformedPNNVOnChange = (option: IPNNVOption | null) => {
    dispatch(setEmdPerformedPNNV(option))
  }

  const setEmdOnChange = (e: CustomEvent) => {
    dispatch(setEmd(e.detail.value))
  }

  const setTypeofServiceOnChange = (option: IOption) => {
    if (standByPurpose && (option?.id !== typeOfServiceStandByOption?.id || null)) setStandByPurposeOnChange(null)
    dispatch(setTypeofService(option))
  }

  const setScheduledOnChange = (option: IOption) => {
    dispatch(setScheduled(option))
  }

  const setStandByPurposeOnChange = (option: IOption | null) => {
    dispatch(setStandbyPurpose(option))
  }

  const setPatientCategoryOnChange = (option: IOption) => {
    dispatch(setPatientCategory(option))
    if (option && PR_PTCAT_DISP_MAP > 0 && PR_DISPATCHED_AS > 0) {
      const isOptionInList = dispatchedAsOptions.some((data) => data.id === option.id)
      if (isOptionInList) setDispatchedAsOnChange(option)
    }
  }

  const setDispatchedAsOnChange = (option: IOption) => {
    dispatch(setDispatchedAs(option))
  }

  const setCallTypeOnChange = (option: IOption) => {
    dispatch(setCallType(option))
  }

  const showDispositionAlert = (option: IDispositionOption) => {
    dispatch(
      showAlert({
        header: '',
        message: t('tripInformation.dispositionOptionWarning'),
        buttons: [
          { text: t('common.buttons.Cancel') },
          {
            text: t('common.buttons.Ok'),
            role: 'destructive',
            handler: () => {
              const updatedTimes = hideDisableDateTimesBasedOnDisposition(option, times)
              dispatch(setDisposition(option))
              dispatch(setTimes(updatedTimes))
            },
          },
        ],
      })
    )
  }

  const setAmbulanceTransportCodeOnChange = (option: IOption) => {
    dispatch(setAmbulanceTransportCode(option))
  }

  const setMassCasualtyOnChange = (option: IOption) => {
    dispatch(setMassCasualty(option))
  }

  const setMassCasualtyPNNVOnChange = (option: IPNNVOption | null) => {
    dispatch(setMassCasualtyPNNV(option))
  }

  const setDispatchLocationOnChange = (e: CustomEvent) => {
    dispatch(setDispatchLocation(e.detail.value))
  }

  const setVehicleGPSNOnChange = (numbers: string[]) => {
    dispatch(setVehicleGPSN(numbers.join('')))
  }

  const setVehicleGPSEOnChange = (numbers: string[]) => {
    dispatch(setVehicleGPSE(numbers.join('')))
  }

  const calculateUsng = () => {
    if (vehicleGPSE !== '' && vehicleGPSN !== '' && PR_USNG === 1) {
      dispatch(calculateVehicleUsng())
    }
  }

  const setVehicleUSNGOnChange = (e: CustomEvent) => {
    dispatch(setVehicleUSNG(e.detail.value))
  }

  const setVehicleGridOnChange = (option: IOption) => {
    dispatch(setVehicleGrid(option))
  }

  const setVehicleMileageStartChange = (numbers: string[]) => {
    dispatch(setVehicleMileageStart(numbers.join('')))
  }

  const setVehicleMileageEndChange = (numbers: string[]) => {
    dispatch(setVehicleMileageEnd(numbers.join('')))
  }

  const setVehicleMileageRefChange = (numbers: string[]) => {
    dispatch(setVehicleMileageRef(numbers.join('')))
  }

  const setVehicleMileageRecChange = (numbers: string[]) => {
    dispatch(setVehicleMileageRec(numbers.join('')))
  }

  const setVehicleMileageLoadedChange = (numbers: string[]) => {
    dispatch(setVehicleMileageLoaded(numbers.join('')))
  }

  const setVehicleMileageTotalChange = (numbers: string[]) => {
    dispatch(setVehicleMileageTotal(numbers.join('')))
  }

  const CalculateVehicleMileageLoadedValue = () => {
    if (
      vehicleMileageRef.replace(/\./g, '') !== '' &&
      vehicleMileageRec.replace(/\./g, '') !== '' &&
      (lpm_lpm === 1 || lpm_lpm === 2)
    ) {
      dispatch(CalculateVehicleMileageLoaded())
    }
  }

  const CalculateVehicleMileageTotalValue = () => {
    if (vehicleMileageStart.replace(/\./g, '') !== '' && vehicleMileageEnd.replace(/\./g, '') !== '' && lpm_lpm === 2) {
      dispatch(CalculateVehicleMileageTotal())
    }
  }

  const forceTenths = (value: string, action?: (number: string[]) => void) => {
    const cleanedValue = removeExtraDecimalPoints(value)
    if (action) {
      let mile = String(cleanedValue)
      if (mile !== '' && FORCE_MILEAGE_TENTHS === 1) {
        if (mile.indexOf('.') === -1) {
          mile += '.0'
        }
        if (mile.substring(mile.length - 1) === '.') {
          mile += '0'
        }
      }
      action(mile.split(''))
    }
  }

  const setUnitDispositionOnChange = (option: IOption) => {
    dispatch(setUnitDisposition(option))
  }

  const setPatientEvaluationOnChange = (option: IOption) => {
    dispatch(setPatientEvaluation(option))
  }

  const setPatientEvaluationPNNVOnChange = (option: IPNNVOption | null) => {
    dispatch(setPatientEvaluationPNNV(option))
  }

  const setCrewDispositionOnChange = (option: IOption) => {
    dispatch(setCrewDisposition(option))
  }

  const setCrewDispositionPNNVOnChange = (option: IPNNVOption | null) => {
    dispatch(setCrewDispositionPNNV(option))
  }

  const setTransportDispositionOnChange = (option: IOption) => {
    dispatch(setTransportDisposition(option))
  }

  const setTransportDispositionPNNVOnChange = (option: IPNNVOption | null) => {
    dispatch(setTransportDispositionPNNV(option))
  }

  const setTeamOnChange = (option: IOption) => {
    dispatch(setTeam(option))
  }

  const setTeamCareOnlyOnChange = (option: IOption) => {
    dispatch(setTeamCareOnly(option))
  }

  const setMaxAltOnChange = (e: CustomEvent) => {
    dispatch(setMaxAlt(e.detail.value))
  }

  const setFlightPlanOnChange = (option: IOption | null) => {
    dispatch(setFlightPlan(option))
  }

  const dispositionRow = (
    <>
      <IonRow>
        <IonCol className='picklist'>
          <SingleSelect
            dataTestID='Disposition'
            options={dispositionOptions}
            selectedOption={disposition}
            listHeader={t('tripInformation.disposition')}
            label={t('tripInformation.disposition')}
            action={showDispositionAlert}
            overrideStateValue={true}
          />
        </IonCol>
      </IonRow>
      <hr className='field-divider' />
    </>
  )

  const dispositionContent = (
    <>
      {dispositionRow}

      <IonRow>
        <IonCol className='picklist'>
          <SingleSelect
            dataTestID='UnitDisposition'
            options={unitDispositionOptions}
            selectedOption={unitDisposition}
            listHeader={t('tripInformation.unitDisposition')}
            label={t('tripInformation.unitDisposition')}
            action={setUnitDispositionOnChange}
          />
          <hr className='field-divider' />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className='picklist'>
          <SingleSelect
            dataTestID='PatientEvaluation'
            options={patientEvaluationOptions}
            selectedOption={patientEvaluation}
            listHeader={t('tripInformation.patientEvaluation')}
            label={t('tripInformation.patientEvaluation')}
            action={setPatientEvaluationOnChange}
            selectedPNNVOption={patientEvaluationPNNV}
            pnnvAction={setPatientEvaluationPNNVOnChange}
          />
          <hr className='field-divider' />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className='picklist'>
          <SingleSelect
            dataTestID='CrewDisposition'
            options={crewDispositionOptions}
            selectedOption={crewDisposition}
            listHeader={t('tripInformation.crewDisposition')}
            label={t('tripInformation.crewDisposition')}
            action={setCrewDispositionOnChange}
            selectedPNNVOption={crewDispositionPNNV}
            pnnvAction={setCrewDispositionPNNVOnChange}
          />
          <hr className='field-divider' />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className='picklist'>
          <SingleSelect
            dataTestID='TransportDisposition'
            options={transportDispositionOptions}
            selectedOption={transportDisposition}
            listHeader={t('tripInformation.transportDisposition')}
            label={t('tripInformation.transportDisposition')}
            action={setTransportDispositionOnChange}
            selectedPNNVOption={transportDispositionPNNV}
            pnnvAction={setTransportDispositionPNNVOnChange}
          />
          <hr className='field-divider' />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className='picklist'>
          <MultiSelect
            dataTestID='ReasonforRefusalRelease'
            label={t('tripInformation.refusalReleaseReason')}
            listHeader={t('tripInformation.refusalReleaseReason')}
            options={refusalReleaseReasonOptions}
            savedValues={refusalReleaseReason}
            action={setRefusalReleaseReason}
          />
        </IonCol>
      </IonRow>
    </>
  )

  const hasDispositionData = () => {
    return (
      (disposition && disposition !== null) ||
      (unitDisposition && unitDisposition !== null) ||
      (crewDisposition && crewDisposition !== null) ||
      (transportDisposition && transportDisposition !== null) ||
      (patientEvaluation && patientEvaluation !== null) ||
      (refusalReleaseReason && refusalReleaseReason.length > 0)
    )
  }

  const getDataTestIdAttribute = inputRef.current?.getAttribute('data-testid')

  return (
    <>
      <IonItemDivider color='light' className='ion-padding'>
        <IonLabel className='grid-item-divider-label' color='medium'>
          {t('tripInformation.tripDetails')}
        </IonLabel>
      </IonItemDivider>
      <IonList>
        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='Base'
              options={baseOptions}
              selectedOption={base}
              listHeader={t('tripInformation.base')}
              label={t('tripInformation.base')}
              action={setBaseOnChange}
              hideClearButton
            />
            <Validation id={TripInformationConstants.SET_BASE} />
          </IonCol>
        </IonRow>

        <hr className='field-divider' />

        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='Unit'
              options={unitOptions}
              selectedOption={unit}
              listHeader={t('tripInformation.unit')}
              label={t('tripInformation.unit')}
              action={setUnitOnChange}
              hideClearButton
            />
            <Validation id={TripInformationConstants.SET_UNIT} />
          </IonCol>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='StaffingLevel'
              options={staffingLevelOptions}
              selectedOption={staffingLevel}
              listHeader={t('tripInformation.staffingLevel')}
              label={t('tripInformation.staffingLevel')}
              action={setStaffingLevelOnChange}
            />
          </IonCol>
        </IonRow>

        <hr className='field-divider' />

        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='UnitEquipment'
              selectedOption={unitEquipment}
              label={t('tripInformation.UnitEquipment')}
              listHeader={t('tripInformation.UnitEquipment')}
              options={unitEquipmentOptions}
              action={unitEquipmentOnChange}
            />
          </IonCol>
        </IonRow>

        <hr className='field-divider' />

        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='Shift'
              options={shiftOptions}
              selectedOption={shift}
              listHeader={t('tripInformation.shift')}
              label={t('tripInformation.shift')}
              action={setShiftOnChange}
            />
          </IonCol>
        </IonRow>

        <hr className='field-divider' />

        {(PR_DISPATCH_ID === 1 || PR_DISPATCH_ID === 2) && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  disabled={isImportedCAD ? true : false}
                  label={t('cadImport.dispatchId')}
                  dataTestID='DispatchId'
                  inputValue={dispatchID}
                  onChangeAction={setDispatchIDOnChange}
                />
                <Validation id={TripInformationConstants.SET_DISPATCH_ID} />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}

        {(PR_LOCAL_ID === 1 || PR_LOCAL_ID === 2) && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  label={PR_LOCAL_ID_LABEL ? PR_LOCAL_ID_LABEL.trim() : t('tripInformation.localID')}
                  dataTestID='LocalId'
                  inputValue={localId}
                  onChangeAction={setLocalIDOnChange}
                />
                <Validation id={TripInformationConstants.SET_LOCAL_ID} />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}

        {PR_TAIL_NUMBER === 1 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='RegistrationTailNumber'
                  options={registrationTailOptions}
                  selectedOption={registrationTailNumber}
                  listHeader={t('tripInformation.registrationTailNumber')}
                  label={t('tripInformation.registrationTailNumber')}
                  action={setRegistrationTailNumberOnChange}
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />
          </>
        )}

        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='dispatchPriority'
              options={dispatchPriorityOptions}
              selectedOption={dispatchPriority}
              listHeader={t('tripInformation.dispatchPriority')}
              label={t('tripInformation.dispatchPriority')}
              action={setDispatchPriorityOnChange}
            />
          </IonCol>
        </IonRow>
        {(PR_DISP_FIELDS === 1 ||
          emdPerformed ||
          emdPerformedPNNV ||
          emd ||
          (isFocused && getDataTestIdAttribute === t('tripInformation.emdCard'))) && (
          <>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='emdPerformed'
                  options={emdPerformedOptions}
                  selectedOption={emdPerformed}
                  listHeader={t('tripInformation.emdPerformed')}
                  label={t('tripInformation.emdPerformed')}
                  action={setEmdPerformedOnChange}
                  selectedPNNVOption={emdPerformedPNNV}
                  pnnvAction={setEmdPerformedPNNVOnChange}
                />
              </IonCol>

              <IonCol className='picklist'>
                <SInput
                  ref={inputRef}
                  isPHI={isPHI}
                  label={t('tripInformation.emdCard')}
                  dataTestID={t('tripInformation.emdCard')}
                  inputValue={emd}
                  onChangeAction={setEmdOnChange}
                  setIsFocused={(focus) => {
                    setIsFocused(focus)
                    handleRef(focus)
                  }}
                />
                <Validation id={TripInformationConstants.SET_EMD} />
              </IonCol>
            </IonRow>
          </>
        )}

        <hr className='field-divider' />

        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='TypeofService'
              options={typeofServiceOptions}
              selectedOption={typeofService}
              listHeader={t('tripInformation.typeofService')}
              label={t('tripInformation.typeofService')}
              action={setTypeofServiceOnChange}
            />
          </IonCol>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='Scheduled'
              options={scheduledOptions}
              selectedOption={scheduled}
              listHeader={t('tripInformation.scheduled')}
              label={t('tripInformation.scheduled')}
              action={setScheduledOnChange}
            />
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
        {isStandbyPurposePicklistVisible && (
          <>
            {' '}
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='StandbyPurpose'
                  options={standByPurposeOptions}
                  selectedOption={standByPurpose}
                  listHeader={t('tripInformation.standByPurpose')}
                  label={t('tripInformation.standByPurpose')}
                  action={setStandByPurposeOnChange}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}

        {(PR_DISPATCHED_LOS > 0 || callType?.id) && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='CallType'
                  disabled={PR_DISPATCHED_LOS == 2}
                  options={callTypeOptions}
                  selectedOption={callType}
                  listHeader={t('tripInformation.callType')}
                  label={t('tripInformation.callType')}
                  action={setCallTypeOnChange}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}

        <IonItemDivider color='light' />
        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='PatientCategory'
              options={patientCategoryOptions}
              selectedOption={patientCategory}
              listHeader={t('tripInformation.patientCategory')}
              label={t('tripInformation.patientCategory')}
              action={setPatientCategoryOnChange}
            />
          </IonCol>
        </IonRow>

        <hr className='field-divider' />
        {PR_DISPATCHED_AS === 1 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='DispatchedAs'
                  options={dispatchedAsOptions}
                  selectedOption={dispatchedAs}
                  listHeader={t('tripInformation.dispatchedAs')}
                  label={t('tripInformation.dispatchedAs')}
                  action={setDispatchedAsOnChange}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}

        {PR_NEMSIS35_DISPOSITION === 0 && dispositionRow}

        {PR_NEMSIS35_DISPOSITION === 1 && (
          <IonRow>
            <IonCol className='ion-no-padding'>
              <AccordianComponent
                dataTestId='Disposition'
                heading={t('tripInformation.disposition')}
                content={dispositionContent}
                isCheckMark={hasDispositionData()}
              />
              <hr className='field-divider' />
            </IonCol>
          </IonRow>
        )}

        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='AmbulanceTransportCode'
              options={ambulanceTransportCodeOptions}
              selectedOption={ambulanceTransportCode}
              listHeader={t('tripInformation.ambulanceTransportCode')}
              label={t('tripInformation.ambulanceTransportCode')}
              action={setAmbulanceTransportCodeOnChange}
            />
          </IonCol>
        </IonRow>

        <hr className='field-divider' />

        {DP_MASSCAS === 1 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='MassCasualty'
                  options={massCasualtyOptions}
                  selectedOption={massCasualty}
                  listHeader={t('tripInformation.massCasualty')}
                  label={t('tripInformation.massCasualty')}
                  action={setMassCasualtyOnChange}
                  selectedPNNVOption={massCasualtyPNNV}
                  pnnvAction={setMassCasualtyPNNVOnChange}
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />
          </>
        )}

        <IonRow>
          <IonCol className='picklist'>
            <SInput
              isPHI={isPHI}
              label={t('tripInformation.dispatchLocation')}
              dataTestID='DispatchLocation'
              inputValue={dispatchLocation}
              onChangeAction={setDispatchLocationOnChange}
              setIsFocused={setIsFocused}
            />
            <Validation id={TripInformationConstants.SET_DISPATCH_LOCATION} />
          </IonCol>
        </IonRow>

        <hr className='field-divider' />

        <IonRow>
          <IonCol className='picklist'>
            <NumberPad
              elementId='VehicleGPSN'
              dataTestId='VehicleGPSN'
              values={vehicleGPSN.toString().split('')}
              label={t('tripInformation.vehicleGPSN')}
              onNumPadClick={setVehicleGPSNOnChange}
              onBlur={calculateUsng}
              validCharacters={geoLocationKeys}
            />
            <Validation id={TripInformationConstants.SET_VEHICLE_GPS_N} />
          </IonCol>
          <IonCol className='picklist'>
            <NumberPad
              elementId='VehicleGPSE'
              dataTestId='VehicleGPSE'
              values={vehicleGPSE.toString().split('')}
              label={t('tripInformation.vehicleGPSE')}
              onNumPadClick={setVehicleGPSEOnChange}
              onBlur={calculateUsng}
              validCharacters={geoLocationKeys}
            />
            <Validation id={TripInformationConstants.SET_VEHICLE_GPS_E} />
          </IonCol>
        </IonRow>

        <hr className='field-divider' />
        {PR_USNG === 1 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  label={t('tripInformation.vehicleUSNG')}
                  dataTestID='vehicleUSNG'
                  inputValue={vehicleUSNG}
                  onChangeAction={setVehicleUSNGOnChange}
                />
                <Validation id={TripInformationConstants.SET_VEHICLE_USNG} />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />
          </>
        )}

        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='VehicleGrid'
              options={vehicleGridOptions}
              selectedOption={vehicleGrid}
              listHeader={t('tripInformation.vehicleGrid')}
              label={t('tripInformation.vehicleGrid')}
              action={setVehicleGridOnChange}
            />
          </IonCol>
        </IonRow>
      </IonList>
      {TEAM_CAPABLE === 1 && (
        <>
          <IonItemDivider color='light' className='ion-padding'>
            <IonLabel className='grid-item-divider-label' color='medium'>
              {t('tripInformation.specialtyInformation')}
            </IonLabel>
          </IonItemDivider>
          <IonList>
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='Team'
                  options={teamOptions}
                  selectedOption={team}
                  listHeader={t('tripInformation.team')}
                  label={t('tripInformation.team')}
                  action={setTeamOnChange}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='TeamCareOnly'
                  options={teamCareOnlyOptions}
                  selectedOption={teamCareOnly}
                  listHeader={t('tripInformation.teamCareOnly')}
                  label={t('tripInformation.teamCareOnly')}
                  action={setTeamCareOnlyOnChange}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <MultiSelect
                  dataTestID='Equipment'
                  options={equipmentOptions}
                  savedValues={equipment}
                  listHeader={t('tripInformation.equipment')}
                  label={t('tripInformation.equipment')}
                  action={setEquipment}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />

            <IonRow>
              <IonCol className='picklist'>
                <MultiSelect
                  dataTestID='ProviderRoles'
                  options={providerRolesOptions}
                  savedValues={providerRoles}
                  listHeader={t('tripInformation.providerRoles')}
                  label={t('tripInformation.providerRoles')}
                  action={setProviderRoles}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </IonList>
        </>
      )}
      {showFlightInfoSection && (
        <>
          <IonItemDivider color='light' className='ion-padding'>
            <IonLabel className='grid-item-divider-label' color='medium'>
              {t('tripInformation.flightInformation')}
            </IonLabel>
          </IonItemDivider>
          <IonList>
            {showMaxAltRow && (
              <>
                <IonRow>
                  <IonCol className='picklist'>
                    <SInput
                      label={t('tripInformation.maxAlt')}
                      dataTestID='maxAlt'
                      inputValue={maxAlt}
                      onChangeAction={setMaxAltOnChange}
                    />
                    <Validation id={TripInformationConstants.SET_MAX_ALT} />
                  </IonCol>
                </IonRow>
                <hr className='field-divider' />
              </>
            )}
            {DP_IFR === 1 && (
              <IonRow>
                <IonCol className='picklist'>
                  <SingleSelect
                    dataTestID='FlightPlan'
                    options={flightPlanOptions}
                    selectedOption={flightPlan}
                    listHeader={t('tripInformation.flightPlan')}
                    label={t('tripInformation.flightPlan')}
                    action={setFlightPlanOnChange}
                  />
                  <Validation id={TripInformationConstants.SET_FLIGHT_PLAN} />
                </IonCol>
              </IonRow>
            )}
          </IonList>
        </>
      )}
      {lpm_odom !== 0 || lpm_lpm !== 0 ? (
        <>
          <IonItemDivider color='light' className='ion-padding'>
            <IonLabel className='grid-item-divider-label' color='medium'>
              {t('tripInformation.mileageLabel')}
            </IonLabel>
          </IonItemDivider>

          <IonList>
            {lpm_odom !== 0 && (
              <>
                <IonRow>
                  {lpm_odom === 2 && (
                    <IonCol>
                      <NumberPad
                        elementId='vehicleMileageStart'
                        dataTestId='vehicleMileageStart'
                        values={vehicleMileageStart.toString().split('')}
                        label={t('tripInformation.vehicleMileageStart')}
                        onNumPadClick={setVehicleMileageStartChange}
                        validCharacters={numberPadKeysWithDecimal}
                        onBlur={() => {
                          forceTenths(vehicleMileageStart, setVehicleMileageStartChange)
                          CalculateVehicleMileageTotalValue()
                        }}
                      />
                      <Validation id={TripInformationConstants.SET_VEHICLE_MILEAGE_START} />
                    </IonCol>
                  )}

                  {(lpm_odom === 1 || lpm_odom === 2) && (
                    <IonCol>
                      <NumberPad
                        elementId='vehicleMileageRef'
                        dataTestId='vehicleMileageRef'
                        values={vehicleMileageRef.toString().split('')}
                        label={t('tripInformation.vehicleMileageRef')}
                        onNumPadClick={setVehicleMileageRefChange}
                        validCharacters={numberPadKeysWithDecimal}
                        onBlur={() => {
                          forceTenths(vehicleMileageRef, setVehicleMileageRefChange)
                          CalculateVehicleMileageLoadedValue()
                        }}
                      />
                      <Validation id={TripInformationConstants.SET_VEHICLE_MILEAGE_REF} />
                    </IonCol>
                  )}
                </IonRow>

                <hr className='field-divider' />
              </>
            )}

            {lpm_odom !== 0 ? (
              <>
                <IonRow>
                  {(lpm_odom === 1 || lpm_odom === 2) && (
                    <IonCol>
                      <NumberPad
                        elementId='vehicleMileageRec'
                        dataTestId='vehicleMileageRec'
                        values={vehicleMileageRec.toString().split('')}
                        label={t('tripInformation.vehicleMileageRec')}
                        onNumPadClick={setVehicleMileageRecChange}
                        validCharacters={numberPadKeysWithDecimal}
                        onBlur={() => {
                          forceTenths(vehicleMileageRec, setVehicleMileageRecChange)
                          CalculateVehicleMileageLoadedValue()
                        }}
                      />
                      <Validation id={TripInformationConstants.SET_VEHICLE_MILEAGE_REC} />
                    </IonCol>
                  )}

                  {lpm_odom === 2 && (
                    <IonCol className='picklist'>
                      <NumberPad
                        elementId='vehicleMileageEnd'
                        dataTestId='vehicleMileageEnd'
                        values={vehicleMileageEnd.toString().split('')}
                        label={t('tripInformation.vehicleMileageEnd')}
                        onNumPadClick={setVehicleMileageEndChange}
                        validCharacters={numberPadKeysWithDecimal}
                        onBlur={() => {
                          forceTenths(vehicleMileageEnd, setVehicleMileageEndChange)
                          CalculateVehicleMileageTotalValue()
                        }}
                      />
                      <Validation id={TripInformationConstants.SET_VEHICLE_MILEAGE_END} />
                    </IonCol>
                  )}
                </IonRow>

                <hr className='field-divider' />
              </>
            ) : null}

            {lpm_lpm !== 0 ? (
              <>
                <IonRow id='mileageSection'>
                  {lpm_lpm === 1 || lpm_lpm === 2 ? (
                    <IonCol className='picklist'>
                      <NumberPad
                        elementId='vehicleMileageLoaded'
                        dataTestId='vehicleMileageLoaded'
                        values={vehicleMileageLoaded.toString().split('')}
                        label={t('tripInformation.vehicleMileageLoaded')}
                        onNumPadClick={setVehicleMileageLoadedChange}
                        validCharacters={numberPadKeysWithDecimal}
                        disabled={vehicleMileageRef !== '' && vehicleMileageRec !== ''}
                        onBlur={() => {
                          forceTenths(vehicleMileageLoaded, setVehicleMileageLoadedChange)
                        }}
                      />
                      <Validation id={TripInformationConstants.SET_VEHICLE_MILEAGE_LOADED} />
                    </IonCol>
                  ) : null}

                  {lpm_lpm === 2 ? (
                    <IonCol className='picklist'>
                      <NumberPad
                        elementId='vehicleMileageTotal'
                        dataTestId='vehicleMileageTotal'
                        values={vehicleMileageTotal.toString().split('')}
                        label={t('tripInformation.vehicleMileageTotal')}
                        onNumPadClick={setVehicleMileageTotalChange}
                        validCharacters={numberPadKeysWithDecimal}
                        disabled={vehicleMileageStart !== '' && vehicleMileageEnd !== ''}
                        onBlur={() => {
                          forceTenths(vehicleMileageTotal, setVehicleMileageTotalChange)
                        }}
                      />
                      <Validation id={TripInformationConstants.SET_VEHICLE_MILEAGE_TOTAL} />
                    </IonCol>
                  ) : null}
                </IonRow>
              </>
            ) : null}
          </IonList>
        </>
      ) : null}

      {isFocused && (
        <IonItemDivider color='light' className={isTabletDevice ? 'bottom-divider-tablet' : 'bottom-divider-mobile'} />
      )}
    </>
  )
}

export default TripInformationContent
